import(/* webpackMode: "eager" */ "/home/interim/frontend/app/services/outstaffing-functions/page.tsx");
